import React, { useState, useEffect } from 'react'
import MUIDataTable from 'mui-datatables'
import moment from 'moment-jalaali'
import { ThemeProvider } from '@material-ui/core/styles'
import { useDispatch, useSelector } from 'react-redux'
import { NotificationModal } from './NotificationModal'
import { getMuiTheme } from '../../utils/TableStyle'
import { deleteNotification, getAllNotifications, seenNotifications } from '../../app/slices/notificationSlice'
import muiDefaultOptions from '../../constants/muiTableOptions'

export const NotificationList = () => {
  const [selectedRow, setSelectedRow] = useState(null)
  const notifications = useSelector((state) => state.notifications.list)
  const count = useSelector((state) => state.notifications.totalHits)
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(muiDefaultOptions.rowsPerPage)
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getAllNotifications({
      after: page * rowsPerPage,
      first: rowsPerPage,
    }))
  }, [rowsPerPage, page])

  const COLUMNS = [
    {
      name: 'row',
      label: 'ردیف',
      options: {
        sort: false,
        filter: false,
        customBodyRender: (value, { rowIndex }) => {
          return (
            <p>
              {rowIndex + 1}
            </p>
          )
        },
      },
    },
    {
      name: 'title',
      label: 'عنوان',
    },
    {
      name: 'content',
      label: 'متن',
    },
    {
      name: 'createDate',
      label: 'تاریخ ایجاد',
      options: {
        customBodyRender: (value) => moment(value)?.format('jYYYY/jMM/jDD'),
      },
    },
  ]

  const handleDelete = (selectedRows) => {
    const notificationsListId = selectedRows?.data?.map((item) => {
      return notifications[item.dataIndex].notificationId
    })
    dispatch(deleteNotification(notificationsListId))
  }

  return (
    <>
      <ThemeProvider theme={getMuiTheme}>
        <MUIDataTable
          data={notifications}
          columns={COLUMNS}
          options={{
            ...muiDefaultOptions,
            selectableRows: 'single',

            rowsPerPage,
            page,
            count,

            serverSide: true,
            filter: false,
            print: false,
            download: false,
            search: false,

            rowHover: true,
            onRowClick: (rowData) => {
              dispatch(seenNotifications([rowData[0]]))
              const item = notifications.find((notif) => notif.notificationId === rowData[0])
              setSelectedRow(item)
            },
            onRowsDelete: (selectedRows) => handleDelete(selectedRows),
            onTableChange: (action, state) => {
              switch (action) {
                case 'changePage': {
                  setPage(state.page)
                  break
                }
                case 'changeRowsPerPage': {
                  setRowsPerPage(state.rowsPerPage)
                  break
                }
                default:
                  break
              }
            },
          }}
        />
      </ThemeProvider>
      <NotificationModal data={selectedRow} open={!!selectedRow} setOpen={setSelectedRow} />
    </>
  )
}

export default NotificationList
